export const newBrandButtonStyle = {
    fontWeight: 400,
    fontSize: '16px',
    minHeight: '36px',
    borderRadius: '8px',
  }

export const newBrandTitleStyle = {
  color: "rgba(74, 74, 74, 1)",
  fontWeight: 600,
}

export const newBrandSubtitleStyle = {
  color: "rgba(74, 74, 74, 1)",
}

export const newBrandBottomHeaderIconStyle = {
  margin: '19px 0',
  display: 'block',
  overflow: 'hidden',
  paddingLeft: 0,
}